import { Projects } from 'constantes/global';
import secureStorage from 'hooks/secureStorage';

// Récupération et parsing des tokens de projet depuis le stockage sécurisé
const project_tokens = secureStorage.getItem('project_tokens')
  ? secureStorage.getItem('project_tokens')
  : [];

console.log('project_tokens', project_tokens);

export let COMMON_URL_PAMOFOR = `https://api.service.digital.cgeds.com/pamofor/`;
export let COMMON_URL_PRESFOR = `https://api.presfor.digital.cgeds.com/presfor/`;
// URLs des projets
export const BASE_URL_PRESFOR = 'https://api.presfor.digital.cgeds.com/';
export const BASE_URL_PAMOFOR = 'https://api.service.digital.cgeds.com/';


// Get project name from project_tokens array
const projectNames = Array.isArray(project_tokens)
  ? project_tokens.map((p) => p.projectName)
  : [];

// console.log('projectNames', projectNames);
if (projectNames.length > 0) {
  if (projectNames.includes(Projects[1]?.label)) {
  }
  if (projectNames.includes(Projects[2]?.label)) {
  }
}

export const REDASH_COMMON_URL = 'https://redash.cgeds.com/';

export const GEOMATIC_URL = 'https://pamofor.goazimut.com/api/';
export const GEOMATIC_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MjcyMzY4MDAsInVzZXJuYW1lIjoiZ2xvYmFsZXhwZXJ0aXNlIiwic2VydmljZXMiOltdLCJpYXQiOjE2OTU2NjgyMTB9.H0KmSPbt8xqOfwgvpolKMbgHh06TyqGR1uM8ndLT9qs';

